// src/DonateChart.js
import React from "react";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";

ChartJS.register(ArcElement, Tooltip, Legend);

const DonateChart = () => {
  const data = {
    labels: ["Community presale", "Airdrop", "Team", "liquidity for Raydium"],
    datasets: [
      {
        data: [10, 5, 5, 80],
        backgroundColor: ["#0279E1", "#00FFF4", "#FF0170", "#000"],
        hoverBackgroundColor: ["#0279E1", "#00FFF4", "#FF0170", "#000"],
        hoverOffset: 10,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          label: function (tooltipItem) {
            return `${tooltipItem.label}: ${tooltipItem.raw}%`;
          },
        },
      },
    },
  };

  return (
    <div className="flex justify-center items-center my-20  ">
      <div className="lg:min-w-[580px] sm:min-w-[380px] sm:min-h-[380px] lg:min-h-[580px] max-w-[270px] sm:max-w-[400px]   relative lg:max-w-[650px] lg:max-h-[650px] min-w-[270px] min-h-[270px]   ">
        <Doughnut data={data} options={options} className="rotate-45 " />
        <div className="absolute hidden sm:block md:top-1/2 top-full sm:top-10 -left-20 md:-left-32 z-20 text-start">
          <p className="text-aircruiser text-black text-2xl md:text-3xl lg:text-[40px]">
            80%
          </p>
          <p className="text-black text-base md:text-lg">
            liquidity for <br /> Raydium
          </p>
        </div>{" "}
        <div className="absolute md:top-16 hidden sm:block sm:top-10 -right-32 md:-right-40 z-20 text-start">
          <p className="text-aircruiser text-black text-2xl md:text-3xl lg:text-[40px]">
            10%
          </p>
          <p className="text-black text-base md:text-lg">Community presale</p>
        </div>{" "}
        <div className="absolute top-[45%] hidden sm:block -right-20 md:-right-28 z-20 text-start">
          <p className="text-aircruiser text-black text-2xl md:text-3xl lg:text-[40px]">
            5%
          </p>
          <p className="text-black text-base md:text-lg">Airdrop</p>
        </div>{" "}
        <div className="absolute top-[63%] hidden sm:block -right-10 md:-right-20 z-20 text-start">
          <p className="text-aircruiser text-black text-2xl md:text-3xl lg:text-[40px]">
            5%
          </p>
          <p className="text-black text-base md:text-lg">Team</p>
        </div>
      </div>
    </div>
  );
};

export default DonateChart;
